import clsx from "clsx";
import dynamic from "next/dynamic";
import Head from "next/head";
import Link from "next/link";
import * as React from "react";
import { createBreakpoint } from "react-use";

import DotsVertical from "@/components/icons/dots-vertical.svg";
import Logo from "~/public/logo.svg";

import Footer from "./page-layout/footer";

const Popover = dynamic(() => import("./popover"), { ssr: false });
export interface PageLayoutProps {
  children?: React.ReactNode;
}

const useBreakpoint = createBreakpoint({ sm: 640, md: 768, lg: 1024 });

const Menu: React.VoidFunctionComponent<{ className: string }> = ({
  className,
}) => {
  return (
    <nav className={className}>
      <Link href="/demo">
        <a
          className={clsx(
            "hover:text-primary-500 text-gray-400 transition-colors hover:no-underline hover:underline-offset-2",
          )}
        >
          Demo
        </a>
      </Link>
      <Link href="https://nasroni.one">
        <a
          className={clsx(
            "hover:text-primary-500 text-gray-400 transition-colors hover:no-underline hover:underline-offset-2",
          )}
        >
          nasroni
        </a>
      </Link>
    </nav>
  );
};

const PageLayout: React.VoidFunctionComponent<PageLayoutProps> = ({
  children,
}) => {
  const breakpoint = useBreakpoint();
  return (
    <div className="bg-pattern min-h-full overflow-x-hidden">
      <Head>
        <title>GLOBI - Support</title>
      </Head>
      <div className="mx-auto flex max-w-7xl items-center py-8 px-8">
        <div className="grow">
          <div className="relative inline-block">
            <Link href="/">
              <a>
                <Logo className="text-primary-500 w-40" alt="GLOBI" />
              </a>
            </Link>
            <span className="absolute -bottom-6 right-0 text-sm text-slate-400 transition-colors">
              Carpe Diem
            </span>
          </div>
        </div>
        <Menu className="hidden items-center space-x-8 md:flex" />
        {breakpoint === "sm" ? (
          <Popover
            placement="left-start"
            trigger={
              <button className="hover:text-primary-500 text-gray-400 transition-colors hover:no-underline hover:underline-offset-2">
                <DotsVertical className="w-5" />
              </button>
            }
          >
            <Menu className="flex flex-col space-y-2" />
          </Popover>
        ) : null}
      </div>
      <div className="md:min-h-[calc(100vh-460px)]">{children}</div>
      <Footer />
    </div>
  );
};

export default PageLayout;